/*LIBRARY*/
import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../../Components/common_modal/Modal";

/*REDUX*/
import {
  logoutUser,
  openModal,
  resetSearchUser,
} from "../../App/actions/authActions";
import checklist from "../../Assets/svg/checklist.svg";
import {
  addGroup,
  getGroups,
  deleteGroup,
  editGroup,
  searchUser,
  addMember,
  set_value_auth,
  push_value_auth,
  delete_value_auth,
} from "../../App/actions/groupActions";
import { getUserPaymentList } from "../../App/actions/paymentActions";
import {
  verify_license_user,
  verify_license_group,
  add_collaborator,
  get_collaborator,
  delete_collaborator,
  invite_collaborator,
  cancel_invite_collaborator,
  invite_via_link,
} from "../../App/actions/license_actions";
import { set_value_user } from "../../App/actions/authActions";
import {
  block_license_with_handler,
  is_pass_license_sharing,
} from "../../App/actions/filter_license";

/*GENERAL*/
// import isEqual from "../../App/validation/is-equal"; // Removed - not used in functional component

/*DATA*/
import dict from "../../Data/dict.json";

/*PICTURE*/
import icon_search from "../../Assets/svg/icon_search.svg";
import pic_static from "../../Assets/svg/profile_pic_comment.svg";

/*CONST*/
const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

const CollaboratorsMenu = ({
  // Destructured props
  auth,
  payment,
  license_reducer,
  // Actions
  addGroup,
  getGroups,
  deleteGroup,
  editGroup,
  searchUser,
  resetSearchUser,
  addMember,
  logoutUser,
  getUserPaymentList,
  openModal,
  verify_license_user,
  verify_license_group,
  set_value_user,
  set_value_auth,
  push_value_auth,
  delete_value_auth,
  add_collaborator,
  get_collaborator,
  delete_collaborator,
  invite_collaborator,
  cancel_invite_collaborator,
  invite_via_link,
  is_pass_license_sharing,
  block_license_with_handler,
}) => {
  const [modal_add_collaborator, setModalAddCollaborator] = useState(false);
  const [search_user, setSearchUser] = useState("");
  const [collaborator_qty, setCollaboratorQty] = useState(
    license_reducer.license_basic?.collaborator_qty ||
      license_reducer.license_user_status?.collaborator_qty
  );
  const [current_collaborator_qty, setCurrentCollaboratorQty] = useState(
    auth.current_collaborator_qty
  );
  const [buttonInviteEmail, setButtonInviteEmail] = useState(false);
  const [buttonInvitePhone, setButtonInvitePhone] = useState(false);
  const [modal_delete, setModalDelete] = useState(false);
  const [userDelete, setUserDelete] = useState({});

  const timerRef = useRef(null);

  useEffect(() => {
    getUserPaymentList();
    getGroups();
    verify_license_group();
  }, [getUserPaymentList, getGroups, verify_license_group]);

  useEffect(() => {
    // lisensi lama
    const old_qty = license_reducer.license_user_status?.collaborator_qty;
    const license_old_qty = old_qty !== collaborator_qty;

    // lisensi baru
    const new_qty = license_reducer.license_basic?.collaborator_qty;
    const license_new_qty = new_qty !== collaborator_qty;

    const old_condition = license_old_qty && old_qty !== undefined;
    const new_condition = license_new_qty && new_qty !== undefined;

    if (old_condition) {
      setCollaboratorQty(old_qty);
    } else if (new_condition) {
      setCollaboratorQty(new_qty);
    }
  }, [
    license_reducer.license_user_status?.collaborator_qty,
    license_reducer.license_basic?.collaborator_qty,
    collaborator_qty,
  ]);

  useEffect(() => {
    const currentCollabLength = auth.collaborators.length;

    if (current_collaborator_qty !== currentCollabLength) {
      setCurrentCollaboratorQty(currentCollabLength);
      set_value_auth({
        key: "current_collaborator_qty",
        value: currentCollabLength,
      });
    }
  }, [auth.collaborators.length, current_collaborator_qty, set_value_auth]);

  const on_change_search_user = (e) => {
    const { value } = e.target;
    clearTimeout(timerRef.current);
    setSearchUser(value);

    timerRef.current = setTimeout(() => trigger_change(), WAIT_INTERVAL);
  };

  const on_key_down = (e) => {
    if (e.keyCode === ENTER_KEY) {
      trigger_change();
    }
  };

  const trigger_change = () => {
    const isEmail = /\S+@\S+\.\S+/.test(search_user);
    const isPhone = /^[0-9]{9,15}$/.test(search_user);

    if (isEmail) {
      setButtonInviteEmail(true);
    } else if (isPhone) {
      setButtonInvitePhone(true);
    } else {
      setButtonInviteEmail(false);
      setButtonInvitePhone(false);
    }

    searchUser(search_user);
  };

  const on_cancel_pending = (collaborators_id, phone_number, email, _id) => {
    cancel_invite_collaborator(collaborators_id, phone_number, email, _id);
  };

  const on_reset_search = () => {
    setSearchUser("");
    resetSearchUser();
  };

  const toggle_delete = (type, group) => {
    if (type === "group") {
      setModalDelete(!modal_delete);
      // Note: Original code referenced contentDelete but it's not used in render
      // Keeping the logic for potential future use
    } else if (type === "collaborator") {
      // Note: Original code set contentDelete but it's not used in render
      // Keeping the logic for potential future use

      setModalDelete(!modal_delete);

      setUserDelete(group);
      // delete_collaborator(group, collaborators, p_id);
    }
  };
  const handleDeleteMember = async () => {
    const { collaborators } = auth;
    const { license_basic, license_user_status } = license_reducer;
    const p_id = license_basic?._id || license_user_status._id;
    await delete_collaborator(userDelete, collaborators, p_id);
    await setModalDelete(false);
    setUserDelete({});
  };

  const on_push_member = (_id, name, full_name, profile_picture) => {
    const body = { _id, name, full_name, profile_picture };
    const { collaborators, current_collaborator_qty } = auth;
    const { license_basic, license_user_status } = license_reducer;
    const p_id = license_basic?._id || license_user_status?._id;
    const payment_type =
      license_basic?.payment_type || license_user_status.payment_type;
    add_collaborator(
      body,
      collaborators,
      current_collaborator_qty,
      collaborator_qty,
      p_id,
      payment_type
    );
  };

  const [modal_warning_self, set_modal_warning_self] = useState(false);
  const [modal_already_in_list, set_modal_already_in_list] = useState(false);

  const toggle_warning_self = () => {
    set_modal_warning_self(!modal_warning_self);
  };

  const toggle_already_in_list = () => {
    set_modal_already_in_list(!modal_already_in_list);
  };

  const handleInvite = () => {
    const language = localStorage?.language || "ina";
    const via = buttonInviteEmail ? "email" : "phone_number";
    const { license_basic, license_user_status } = license_reducer;
    const payment_id = license_basic?._id || license_user_status?._id;
    invite_collaborator(payment_id, search_user, via, language).catch((err) =>
      console.error(err)
    );

    setButtonInviteEmail(false);
    setButtonInvitePhone(false);
  };

  const handleCopy = () => {
    const inputElement = document.getElementById("copyInput");
    inputElement.select();
    document.execCommand("copy");
  };

  const toggle_add_collaborator = () => {
    on_reset_search();
    if (is_pass_license_sharing()) {
      setModalAddCollaborator(!modal_add_collaborator);
    }
  };

  const toggle_add_people = () => {
    if (is_pass_license_sharing()) {
      const { license_basic, license_user_status } = license_reducer;
      invite_via_link(license_basic._id || license_user_status._id);
      setModalAddCollaborator(!modal_add_collaborator);
    } else {
      block_license_with_handler();
      setModalAddCollaborator(false);
    }
  };

  const language = localStorage?.language || "ina";

  //global props
  const {
    user_list,
    collaborators,
    pending_collaborators,
    link_invitation,
    user,
  } = auth;
  const {
    license_basic,
    license_user_status,
    license_sharing,
    license_group_status,
  } = license_reducer;

  const payment_type =
    license_basic?.payment_type || license_user_status?.payment_type;

  const modal_warning_self_content = modal_warning_self && (
    <Modal
      modalSize="small"
      isOpen={modal_warning_self}
      onClose={toggle_warning_self}
    >
      <div className="box-body">
        <p className="text_bold margin_bottom_extra">
          Tidak bisa menambahkan diri anda sendiri
        </p>
        <button
          className="button_big button_white outline_black"
          onClick={toggle_warning_self}
        >
          Okay
        </button>
      </div>
    </Modal>
  );

  const modal_already_in_list_content = modal_already_in_list && (
    <Modal
      modalSize="small"
      isOpen={modal_already_in_list}
      onClose={toggle_already_in_list}
    >
      <div className="box-body">
        <p className="text_bold margin_bottom_extra">
          User ini sudah ditambahkan
        </p>
        <button
          className="button_big button_white outline_black"
          onClick={toggle_already_in_list}
        >
          Okay
        </button>
      </div>
    </Modal>
  );

  const modal_add_collaborator_component = modal_add_collaborator && (
    <Modal
      modalSize="medium"
      id="deleteModal"
      isOpen={modal_add_collaborator}
      onClose={toggle_add_collaborator}
    >
      <div className="box-body">
        Link Invitation:
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            id="copyInput"
            type="text"
            value={link_invitation}
            readOnly
            style={{
              flex: 1,
              padding: "10px",
              marginRight: "10px",
            }}
          />
          <button onClick={handleCopy}>Copy</button>
        </div>
      </div>
    </Modal>
  );

  const modal_delete_user = modal_delete && (
    <Modal
      modalSize="small"
      isOpen={modal_delete}
      onClose={() => {
        setModalDelete(false);
        setUserDelete({});
      }}
    >
      <div className="box-body" style={{ textAlign: "center" }}>
        <div className="text_medium">
          {dict["Are you sure to delete"][language]}
        </div>
        <br />
        <div className="text_bold" style={{ textAlign: "center" }}>
          {userDelete?.full_name ? userDelete?.full_name : userDelete?.name}
        </div>
        <br />
        <div
          onClick={handleDeleteMember}
          className="button_very_small background_red"
          data-mapid="clickDeleteModal"
        >
          {dict["Delete"][language]}
        </div>
      </div>
    </Modal>
  );
  const punya_license_sharing = license_group_status.is_has_license
    ? license_group_status
    : license_sharing;

  const profile_picture =
    punya_license_sharing?.user?.profile_picture ||
    license_group_status?.user?.profile_picture;

  const profilePic =
    profile_picture && profile_picture?.url_compressed
      ? profile_picture?.url_compressed
      : profile_picture &&
        profile_picture?.url &&
        ![
          "https://s3-us-west-2.amazonaws.com/geomapid-assets/astronot.png",
          "-",
          "default",
        ].includes(profile_picture.url)
      ? profile_picture?.url
      : pic_static;

  return (
    <div style={{ minHeight: "100vh" }}>
      {modal_add_collaborator_component}
      {modal_warning_self_content}
      {modal_already_in_list_content}
      {modal_delete_user}

      <div style={{ flex: 1, padding: "20px" }}>
        {punya_license_sharing.is_has_license ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <p>License support by:</p>
            <div
              style={{
                display: "flex",
                alignItems: "start",
                backgroundColor: "#fff",
                padding: "10px",
                marginBottom: "10px",
                borderRadius: "6px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <section
                  alt={punya_license_sharing?.user.name}
                  className="user-photo"
                  style={{
                    backgroundImage: `url(${profilePic})`,
                    marginRight: "10px",
                  }}
                />
                <span>{punya_license_sharing?.user.full_name}</span>
              </div>
            </div>
          </div>
        ) : null}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p>
            Collaborator members:
            {(["team", "license_2"].includes(payment_type) ||
              (punya_license_sharing.is_has_license &&
                parseInt(collaborator_qty) > 0)) && (
              <span>
                ({collaborators.length}/{collaborator_qty})
              </span>
            )}
            {(["enterprise", "license_3"].includes(payment_type) ||
              punya_license_sharing.is_has_license) && (
              <span>({collaborators.length})</span>
            )}
          </p>
          {punya_license_sharing.is_has_license ? null : (
            <button
              onClick={toggle_add_people}
              className="button_big background_black"
              data-mapid="clickAddMember"
            >
              Invitation link
            </button>
          )}
        </div>

        <div style={{ display: "flex", marginBottom: "20px" }}>
          <div style={{ flex: 1, marginLeft: "20px" }}>
            {punya_license_sharing.is_has_license ? null : (
              <div
                className="input_rounded margin_top"
                style={{ width: "100%", boxSizing: "border-box" }}
              >
                <div className="icon-text">
                  <section>
                    <img
                      src={icon_search}
                      alt="search"
                      height="16px"
                      className="margin_right"
                    />
                  </section>
                  <section>
                    <input
                      className="form-rounded"
                      type="text"
                      placeholder={`Search user to add as collaborator`}
                      autoComplete="off"
                      name="search_user"
                      value={search_user}
                      onChange={on_change_search_user}
                      onKeyDown={on_key_down}
                      data-mapid="inputUser"
                    />
                  </section>
                  <section>
                    <div
                      onClick={on_reset_search}
                      style={{ margin: "5px", cursor: "pointer" }}
                    >
                      X
                    </div>
                  </section>
                </div>
                <main style={{ maxHeight: "300px", overflowY: "auto" }}>
                  {user_list.map(
                    ({ _id, name, full_name, profile_picture }, idx) => {
                      const alreadyInList = collaborators.some(
                        (collab) => collab._id === _id
                      );
                      const displayName =
                        full_name && full_name !== "" && full_name !== "-"
                          ? full_name
                          : name;
                      const profilePic =
                        profile_picture && profile_picture.url_compressed
                          ? profile_picture.url_compressed
                          : profile_picture &&
                            profile_picture.url &&
                            ![
                              "https://s3-us-west-2.amazonaws.com/geomapid-assets/astronot.png",
                              "-",
                              "default",
                            ].includes(profile_picture.url)
                          ? profile_picture.url
                          : pic_static;

                      return (
                        <main
                          key={idx}
                          className={`user-unit  non-member`}
                          onClick={() => {
                            if (user?._id === _id) {
                              toggle_warning_self();
                            } else if (!alreadyInList) {
                              on_push_member(
                                _id,
                                name,
                                full_name,
                                profile_picture
                              );
                            } else {
                              toggle_already_in_list();
                            }
                          }}
                          data-mapid={`clickUser-${idx}`}
                        >
                          <section
                            alt={_id}
                            className="user-photo"
                            style={{ backgroundImage: `url(${profilePic})` }}
                          />
                          <section className="user-name">{displayName}</section>
                          {alreadyInList && (
                            <section
                              alt={_id}
                              className="badge-member"
                              style={{ backgroundImage: `url(${checklist})` }}
                            />
                          )}
                        </main>
                      );
                    }
                  )}
                </main>
              </div>
            )}

            <br />

            {buttonInviteEmail && (
              <div>
                <button
                  className="button background_black"
                  onClick={handleInvite}
                  type="InviteEmail"
                  data-mapid="clickInviteEmail"
                >
                  Invite by Email
                </button>
                <br />
              </div>
            )}
            {buttonInvitePhone && (
              <div>
                <button
                  className="button background_black"
                  onClick={handleInvite}
                  type="InviteEmail"
                  data-mapid="clickInviteEmail"
                >
                  Invite by WhatsApp
                </button>
                <br />
              </div>
            )}

            <br />
            <div>
              {collaborators.map((collaborator, idx) => {
                const _id = collaborator?._id;
                const name = collaborator?.name;
                const full_name =
                  collaborator?.full_name || name || `member ${idx}`;
                const profile_picture = collaborator?.profile_picture;

                const displayName =
                  full_name && full_name !== "" && full_name !== "-"
                    ? full_name
                    : name;
                const profilePic =
                  profile_picture && profile_picture.url_compressed
                    ? profile_picture.url_compressed
                    : profile_picture &&
                      profile_picture.url &&
                      ![
                        "https://s3-us-west-2.amazonaws.com/geomapid-assets/astronot.png",
                        "-",
                        "default",
                      ].includes(profile_picture.url)
                    ? profile_picture.url
                    : pic_static;

                return (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#fff",
                      padding: "10px",
                      marginBottom: "10px",
                      borderRadius: "6px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ marginRight: "10px" }}>
                        {parseInt(idx + 1)}
                      </span>

                      <section
                        alt={_id}
                        className="user-photo"
                        style={{
                          backgroundImage: `url(${profilePic})`,
                          marginRight: "10px",
                        }}
                      />
                      <span>{displayName}</span>
                    </div>
                    {punya_license_sharing.is_has_license ? null : (
                      <button
                        className="button_very_small background_red"
                        data-mapid="clickDeleteModal"
                        onClick={() =>
                          toggle_delete("collaborator", {
                            _id,
                            name,
                            full_name,
                            profile_picture,
                          })
                        }
                      >
                        {dict["Kick"][language]}
                      </button>
                    )}
                  </div>
                );
              })}

              {pending_collaborators.length > 0 && (
                <div>
                  <hr />
                  <p>Pending Collaborators</p>
                  <br />
                  {pending_collaborators.map(
                    (
                      { collaborators_id, phone_number, email, _id, via },
                      idx
                    ) => {
                      const picture_src =
                        "https://s3-us-west-2.amazonaws.com/geomapid-assets/astronot.png";

                      return (
                        <div
                          key={idx}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            backgroundColor: "#fff",
                            padding: "10px",
                            marginBottom: "10px",
                            borderRadius: "6px",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <section
                              alt={idx}
                              className="user-photo"
                              style={{
                                backgroundImage: `url(${picture_src})`,
                                marginRight: "10px",
                              }}
                            />
                            <div>
                              <div>{phone_number ? phone_number : email}</div>
                              <div
                                style={{
                                  color: "grey",
                                  fontSize: "10px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {email
                                  ? via === "email"
                                    ? "Invited by Email"
                                    : "Invited by Phone Number"
                                  : "Invited by Phone Number"}
                              </div>
                            </div>
                          </div>
                          <button
                            className="button_very_small background_red"
                            data-mapid="clickDeleteModal"
                            onClick={() =>
                              on_cancel_pending(
                                collaborators_id,
                                phone_number,
                                email,
                                _id
                              )
                            }
                          >
                            {dict["Cancel"][language]}
                          </button>
                        </div>
                      );
                    }
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
  license_reducer: state.license_reducer,
});

export default connect(mapStateToProps, {
  addGroup,
  getGroups,
  deleteGroup,
  editGroup,
  searchUser,
  resetSearchUser,
  addMember,
  logoutUser,
  getUserPaymentList,
  openModal,
  verify_license_user,
  verify_license_group,
  set_value_user,
  set_value_auth,
  push_value_auth,
  delete_value_auth,
  add_collaborator,
  get_collaborator,
  delete_collaborator,
  invite_collaborator,
  cancel_invite_collaborator,
  invite_via_link,
  is_pass_license_sharing,
  block_license_with_handler,
})(CollaboratorsMenu);
